import React, { Component } from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { TimelineMax, Power1 } from "gsap/all";

class Experience extends Component {
  constructor(props) {
    super(props);
    this.Experiences = {
      "main_title": "Experiences",
      "main_title_description": "“Protons give an atom its identity, electrons its personality.” <br />- Bill Bryson, A short history of nearly everything",
      "firms": {
        "1": {
          "firm_details": [
            { "name": "i2e Consulting" },
            { "url": "https://www.i2econsulting.com/" },
            { "logo": "https://www.i2econsulting.com/wp-content/uploads/2019/04/i2econsulting-logo.png" },
            { "location": "Mumbai, India" }
          ],
          "period": [
            { "from": "May 2020" },
            { "to": "Present" }
          ],
          "designation": "Senior UI Developer",
          "responsibilities": [
            "Creating responsive websites in HTML5.",
            "Creating and managing plugins as per project requirements.",
            "Using good programming techniques to ensure a stable web environment.",
            "Optimizing websites and analyze website speed performance.",
            "Managing UI development issues and queries."
          ],
          "works": [
            { "name": "i2e Consulting" },
            { "url": "https://www.i2econsulting.com/" },
            { "description": "https://www.i2econsulting.com/" }
          ]
        },
        "2": {
          "firm_details": [
            { "name": "Hepta" },
            { "url": "https://www.hepta-agency.com/" },
            { "logo": "https://images.squarespace-cdn.com/content/5e5648796615385f59325098/1582813814611-GEK26YLM5ZMH02HUBUSK/Bw+logo.png?content-type=image%2Fpng" },
            { "location": "Mumbai, India" }
          ],
          "period": [
            { "from": "July 2019" },
            { "to": "January 2020" }
          ],
          "designation": "Senior UI Developer",
          "responsibilities": [
            "Creating responsive websites in HTML5.",
            "Creating and managing plugins as per project requirements.",
            "Using good programming techniques to ensure a stable web environment.",
            "Optimizing websites and analyze website speed performance.",
            "Managing UI development issues and queries."
          ],
          "works": {
            "0":
              [
                { "name": "Ikaigai" },
                { "url": "http://ikaigai.com/" },
                { "description": "Ikaigai is a multi-brand contemporary furniture store located in the heart of Mumbai. Did the UI development for the website along with interactions." }
              ],
            "1":
              [
                { "name": "BlueLoft" },
                { "url": "https://www.blueloft.com/" },
                { "description": "Blue Loft is a design-centric contemporary furniture brand that targets the urban consumer seeking expert craftsmanship. Did the UI development for the website along with interactions and animations." }
              ]
          }
        },
        "3": {
          "firm_details": [
            { "name": "Gozoop" },
            { "url": "https://www.gozoop.com/" },
            { "logo": "https://www.gozoop.com/img/gozoop-red-logo-1000x1000.svg" },
            { "location": "Mumbai, India" }
          ],
          "period": [
            { "from": "February 2017" },
            { "to": "June 2019" }
          ],
          "designation": "Senior UI Developer",
          "responsibilities": [
            "AWS account creation and complete server setup.",
            "Creating responsive websites and plugins in HTML5.",
            "Maintained client websites, troubleshooting issues and updating software while ensuring full functional compatibility.",
            "Integrating backend for micro-sites in PHP.",
            "Integrating website leads into Salesforce.",
            "Collaborated with other UI and database development professionals to seamlessly integrate code to create a dynamic and functional user experience."
          ],
          "works": {
            "0":
              [
                { "name": "Aditya Birla Fashion and Retail Limited (ABFRL)" },
                { "url": "http://abfrl.com/" },
                { "description": "Aditya Birla Fashion and Retail Ltd, India's largest Apparel and Retail Company, is part of Aditya Birla Group. Did the UI development for the website along with interactions." }
              ],
            "1":
              [
                { "name": "High Street Phoenix" },
                { "url": "http://www.highstreetphoenix.com/" },
                { "description": "High Street Phoenix, formerly known as Phoenix Mall, is one of the largest shopping malls in India. Did the UI development for the website along with interactions." }
              ]
          }
        },
        "4": {
          "firm_details": [
            { "name": "EvolutionCo" },
            { "url": "https://www.evolutionco.com/" },
            // { "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ1wl08rxZRpwSuEb7IBNKp7Hy7Ba_Kd1R7Ow&usqp=CAU" },
            { "logo": "https://www.evolutionco.com/assets/site/img/logo/evolutionco-logo_white.svg" },
            { "location": "Mumbai, India" }
          ],
          "period": [
            { "from": "June 2016" },
            { "to": "January 2017" }
          ],
          "designation": "UI Developer",
          "responsibilities": [
            "Creating responsive websites in HTML5.",
            "Creating and managing themes in Drupal CMS.",
            "Using good programming techniques to ensure a stable web environment."
          ],
          "works": {
            "0":
              [
                { "name": "Club Mahindra Bliss" },
                { "url": "bliss.clubmahindra.com" },
                { "description": "Club Mahindra provides holidays on a timeshare basis and is a part of Mahindra Group. Build the complete website to new responsive website in Drupal CMS." }
              ]
          }
        },
        "5": {
          "firm_details": [
            { "name": "Digital Arts" },
            { "url": "https://www.digitalarts.co.in/" },
            { "logo": "https://www.digitalarts.co.in/images/logo.jpg" },
            { "location": "Mumbai, India" }
          ],
          "period": [
            { "from": "September 2013" },
            { "to": "June 2016" }
          ],
          "designation": "Web Developer/Designer",
          "responsibilities": [
            "Creating and customizing responsive websites in HTML5.",
            "Creating and managing E-commerce and CMS websites.",
            "Converting raw images and PSD layouts from a graphic designer into CSS/HTML themes.",
            "Registering web domain names and organizing the hosting of the website.",
            "Updating websites utilizing ASP.NET, HTML, PHP.",
            "Post-sales technical support and training client's staff for CMS type websites.",
            "Attending client meetings during the sales process and during development."
          ],
          "works": {
            "0":
              [
                { "name": "Potentia HR" },
                { "url": "potentiahr.com" },
                { "description": "Potentia HR is Indonesia's leading Headhunting & Executive Search firm, with a focus on Retained Executive Recruitment. Revamped the complete website to new responsive website in Joomla CMS." }
              ],
            "1":
              [
                { "name": "Cornerstone India" },
                { "url": "cornerstone.co.in" },
                { "description": "Cornerstone India provides global reach and local high quality services to clients ranging from the world’s largest multi-national corporations to small local companies. Revamped the complete website to new responsive website in Joomla CMS." }
              ]
          }
        }
      }
    };
    this.state = {
      experience: this.Experiences
    };
    this.timeline = new TimelineMax({ paused: true });
    this.headerDivs = [];
    this.contentDivs = [];
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.timeline
      .staggerFrom(this.headerDivs, 0.4, {
        autoAlpha: 0,
        // stagger: 0.1,
        //x: 25,
        delay: 0.25,
        ease: Power1.easeInOut
      }, 0.2)
      .staggerFrom(this.contentDivs, 0.4, {
        autoAlpha: 0,
        // stagger: 0.1,
        x: 25,
        ease: Power1.easeInOut
      }, 0.2);

    this.timeline.play();
  }
  componentDidUpdate(prevProps) {
    // if (this.props.location !== prevProps.location) {
    window.scrollTo(0, 0);
    // }
  }
  render() {
    const props = this.props;
    let experience = this.state.experience;
    let firms = this.state.experience.firms;
    // console.log(firms);
    return (
      <div className="view-page-container experience-page">
        <div className="container">
          <h2 className="text-center main-header" ref={div => (this.headerDivs[1] = div)}>{experience.main_title}</h2>
          <div className="text-center lead" ref={div => (this.headerDivs[2] = div)} dangerouslySetInnerHTML={{ __html: experience.main_title_description }} />
          <hr />
          {/* <div><pre>{JSON.stringify(experience, null, 2)}</pre></div> */}
          {/* <div className="experiences">
            {
              Object.keys(firms).map((firm_no, i) => (
                // console.log(firms[firm_no].firm_details[0]['name']),
                <div className="experience-item row pb-3" key={i} ref={div => (this.contentDivs[i] = div)}>
                  <div className="col-md-4">
                    <h4>{firms[firm_no].firm_details[0]['name']}</h4>
                    <a className="firm-img d-inline-block" href={firms[firm_no].firm_details[1]['url']} target="_blank" rel="noopener noreferrer">
                      <img src={firms[firm_no].firm_details[2]['logo']} alt="{firms[firm_no].firm_details[0]['name']}" className="img-fluid" />
                    </a>
                    <div className="experience-period">
                      {firms[firm_no].period[0]['from']}-{firms[firm_no].period[1]['to']}
                    </div>
                    <a className="firm-url d-inline-block" href={firms[firm_no].firm_details[1]['url']} target="_blank" rel="noopener noreferrer">
                      {firms[firm_no].firm_details[1]['url']}
                    </a>
                    {(() => {
                      let location = firms[firm_no].firm_details[3];
                      if (location) {
                        return (
                          // console.log('no location'),
                          <div className="location">
                            <FaMapMarkerAlt></FaMapMarkerAlt>
                            {firms[firm_no].firm_details[3]['location']}
                          </div>
                        )
                      }
                    })()}
                  </div>
                  <div className="col-md-8">
                    <div>
                      <strong>Designation: {firms[firm_no].designation}</strong>
                      <div className="hidden-phone">
                        Responsibilities:
                        <ul>
                          {
                            firms[firm_no].responsibilities.map((item, j) =>
                              <li key={j}>{item}</li>
                            )
                          }
                        </ul>
                      </div>
                      <div className="experience-details">
                      </div>
                    </div>
                  </div>
                </div>
              ))
            }
          </div> */}
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="main-timeline">
                {/* <a href={void (0)} className="timeline">
                  <div className="timeline-icon"><i className="fa fa-globe"></i></div>
                  <div className="timeline-content">
                    <h3 className="title">Web Designer</h3>
                    <p className="description">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cupiditate ducimus officiis quod! Aperiam eveniet nam nostrum odit quasi ullam voluptatum.
                          </p>
                  </div>
                </a> */}
                {
                  Object.keys(firms).map((firm_no, i) => (
                    // console.log(firms[firm_no].firm_details[0]['name']),
                    <div className="timeline" key={i}>
                      <a className="timeline-icon" href={firms[firm_no].firm_details[1]['url']} target="_blank" rel="noopener noreferrer">
                        <img className="timeline-icon-img" src={firms[firm_no].firm_details[2]['logo']} alt="" />
                      </a>
                      <div className="timeline-content">
                        <h3 className="title">{firms[firm_no].designation}</h3>
                        <h4 className="company-name">{firms[firm_no].firm_details[0]['name']}</h4>
                        <a className="firm-url d-inline-block" href={firms[firm_no].firm_details[1]['url']} target="_blank" rel="noopener noreferrer">
                          {firms[firm_no].firm_details[1]['url']}
                        </a>
                        {(() => {
                          let location = firms[firm_no].firm_details[3];
                          if (location) {
                            return (
                              // console.log('no location'),
                              <div className="location">
                                <FaMapMarkerAlt></FaMapMarkerAlt>
                                {firms[firm_no].firm_details[3]['location']}
                              </div>
                            )
                          }
                        })()}
                        <div className="description">
                          {firms[firm_no].period[0]['from']}-{firms[firm_no].period[1]['to']}
                          <ul>
                            {
                              firms[firm_no].responsibilities.map((item, j) =>
                                <li key={j}>{item}</li>
                              )
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Experience;
